<div #subscriberDiv></div>
<a id="lnkClose" class="grid-link" (click)="closeVideo()">
    <i class="fas fa-times video-close"  aria-hidden="true"></i>
</a>
